var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout--full-page"},[_c('vs-progress',{directives:[{name:"show",rawName:"v-show",value:(_vm.isProgressing),expression:"isProgressing"}],attrs:{"indeterminate":"","color":"primary"}}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }